import React, { useState } from "react";

import LanguageContext from "./languageContext";
import { textLang } from "../text/text-language";

const LanguageState = ({ children }) => {
  const langAvailable = {
    ESPAÑOL: "ES",
    ENGLISH: "EN",
  };

  const [language, setLanguage] = useState(textLang.english);
  const [wichOne, setWichOne] = useState(langAvailable.ENGLISH);

  //   This is an onClick to change the language from spanish to english and reversly.
  const chooseLanguage = (e) => {
    e.preventDefault();
    if (e.target.value === langAvailable.ENGLISH) {
      setLanguage(textLang.english);
      setWichOne(langAvailable.ENGLISH);
    }
    if (e.target.value === langAvailable.ESPAÑOL) {
      setLanguage(textLang.spanish);
      setWichOne(langAvailable.ESPAÑOL);
    }
  };

  return (
    <LanguageContext.Provider
      value={{
        wichOne,
        language,
        langAvailable,
        chooseLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageState;
